module.exports = require('./$.global').document && document.documentElement;


/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/modules/$.html.js
 ** module id = 215
 ** module chunks = 0
 **/